<template>
  <component
    v-if="ads.length"
    :is="noSection ? 'div' : 'section'"
    :class="['ad-banner', { '--no-section': noSection }]"
  >
    <div class="ad-banner__inner">
      <h2 class="ad__label">{{ $t('ad.label') }}</h2>

      <div class="ad-banner__list">
        <a
          v-for="ad in ads"
          class="ad"
          :href="ad.link"
          target="_blank"
          :title="ad.title"
          :key="`ad-${ad.id}`"
        >
          <AdImage :images="ad.images" />
        </a>
      </div>
    </div>
  </component>
</template>

<script>
import AdImage from '@/components/small/AdImage.vue'

export default {
  name: 'AdBanner',
  components: { AdImage },
  props: {
    ads: {
      type: Array,
      default: [],
    },
    noSection: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
